import { atom } from "recoil";

export type InterphoneType = {
  type: string | null;
  interphone_call_manage_id: number | null;
  room_name: number | null;
  status: number; // 0: 통화상태 아님, 1: 송신자 대기중, 2: 수신자 대기중, 3: 통화중, 4: 통화 불가 상태, 5: 접속 대기(RECCEIVER_ACCEPT)
  reject_reason?: string;
};

export type MissedCallType = {
  manage_id: number;
  sender: string;
  sender_id: number;
  sender_name: string;
  called_at: string;
};

export const interphoneAreaState = atom<string | null>({
  key: "interphoneArea",
  default: null,
});

export const interphoneState = atom<InterphoneType>({
  key: "interphone",
  default: {
    type: null,
    interphone_call_manage_id: null,
    room_name: null,
    status: -1,
  },
});
